(ns portal.service-keys.ocp
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/wpp/content-actions/copy.svg$default" :as CopyIcon]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.service-key :as q]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui token-section [{:keys [token]}]
  ($ Paper {:elevation 0
            :sx #js {:p (if token 1 2) :borderRadius 2 :backgroundColor "grey.80"}}
     (if token
       ($ Stack {:spacing 1}
          ($ Typography {:variant "h4" :sx #js {:px 0.5}} "Service Key Token")
          ($ Stack {:direction    "row"
                    :alignItems   "flex-start"
                    :sx           #js {:borderRadius 1
                                       :backgroundColor "background.paper"
                                       :border "1px solid"
                                       :borderColor "grey.60"}}
             ($ Typography {:sx      #js {:flexGrow 1 :wordBreak "break-all" :fontFamily "monospace"
                                          :py 1
                                          :pl 1}}
                token)
             ($ IconButton {:onClick #(-> js/navigator .-clipboard (.writeText token))
                            :size    "small"
                            :sx #js {:mt 0.5 :mr 0.5}}
                ($ CopyIcon)))
          ($ Typography {:variant "caption" :color "text.secondary" :sx #js {:px 0.5}}
             "Make sure to copy this token — once you close this panel, it cannot be retrieved."))
       ($ Stack {:spacing 1 :alignItems "center"}
          ($ Typography {:variant "h4"} "Service Key Token")
          ($ Typography {:variant "body2" :color "text.secondary" :align "center"}
             "Once created, your token will appear here. Copy it before closing this panel — it cannot be retrieved again.")
          ($ Button {:variant "contained" :type "submit"}
             "Create token")))))

(defui create-footer [{:keys [token-phase]}]
  ($ Stack {:direction "row" :justifyContent "flex-end"}
     ($ Button
        {:variant (if token-phase "contained" "outlined")
         :type "button"
         :on-click #(rf/dispatch [:ocp/close])}
        (if token-phase "Close" "Cancel"))))

(defocp service-key-ocp :service-key/create {:width "30%"} [_props]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        [token set-token!] (uix/use-state nil)

        {role-options :data} (use-query (q/roles-query))

        {:keys [control handleSubmit]} (form/use-form #js {:defaultValues #js {:name "" :role nil}
                                                           :disabled (boolean token)})

        {create-key :mutate} (use-mutation (q/create-service-key-mutation {:advertiser-id advertiser-id}))

        on-submit (fn [^js data]
                    (let [{:keys [name role]} (->clj data)]
                      (create-key {:advertiser-id    advertiser-id
                                   :service-key-name name
                                   :role-id          (:id role)}
                                  #js {:onSuccess (fn [^js response]
                                                    (set-token! (:token (->clj response))))})))]

    ($ ocp {:title     (if token "Service Key Created" "New Service Key")
            :on-submit (when-not token (handleSubmit on-submit))
            :footer    ($ create-footer {:token-phase (boolean token)})}
       ($ Stack {:spacing 3}
          ($ form-field {:label "Name" :required? true}
             ($ form/form-text-field
                {:name    "name"
                 :control control
                 :rules   #js {:required "Name is required"}}))
          ($ form-field {:label "Role" :required? true}
             ($ form/autocomplete-field
                {:name       "role"
                 :control    control
                 :rules      #js {:required "Role is required"}
                 :field-props {:options   role-options
                               :placeholder "Select a role"}}))
          ($ token-section {:token token})))))
